
<ng-template #template1>
  <div class="modal-header border-0 pb-0">
    <div class="custom-tab d-block w-100">
      <button type="button" class="close hide close-abs pull-right text-right" id="editclose" name="editclose" #editclose aria-label="Close" (click)="filterVal.startIndex = 1;modalMeeting.hide();loadGeneralInfo();">
        <span aria-hidden="true"></span>
      </button>

    </div>
  </div>

  <app-view-meeting pagetype="MEETING" [mid]="mid" (editPopUpClose)="getPopUpOutput($event)"></app-view-meeting>


</ng-template>

<ng-template #template>
  <div class="modal-header pb-0">
    <div class="custom-tab d-block w-100">
      <h4 class="modal-title text-left px-2">Create new MOM </h4> <small class="px-2"><a class="text-secondary" (click)="filterVal.startIndex = 1;modalRef.hide();loadGeneralInfo();"><i class="ti ti-arrow-left"></i> Back to Meeting Minutes</a></small>
      <button type="button" class="close close-abs text-right" id="addclose" name="addclose" #addclose aria-label="Close" (click)="filterVal.startIndex = 1;modalRef.hide();loadGeneralInfo();">
        <span aria-hidden="true"><i class="la la-close"></i></span>
      </button>

    </div>
  </div>
  <app-add-meeting pagetype="MEETING"></app-add-meeting>

</ng-template>
<div class="bg-light border-bottom ">
  <div class="container-fluid clearfix p-2">
    <div class="float-md-right float-sm-right float-xs-right top-nav-btn res-fixed-x-space">
      <!--<div class="page-title-box d-flex justify-content-between bd-highlight mb-3 pb-4">
    <h4 class="mb-0 f-bold-dubai text-secondary pb-4">User view</h4>
    <div class="page-title-right pb-4"><a class="btn btn-secondary btn-sm text-white" ><i class="fa fa-arrow-left"></i> Back</a></div>
  </div>
  <div class="d-inline-block mx-1 py-2">
    <button type="button" (click)="exportXL()" class="px-3 btn btn-sm text-left btn-block d-sm-block btn-outline-light-gray  font-weight-bold"><i class="ti ti-export"></i> Export</button>
  </div>-->
      <div class="d-inline-block mx-1 py-2 drop-minus-top pointer">
        <select id="inputState" (change)="onChangeSortBy($event.target.value)"
                class="px-3 form-control btn-block d-sm-block form-control-sm font-weight-bold px-2">
          <option selected value="date">Sort by Created</option>
          <option value="meetingdate">Sort by Meeting Date</option>
          <option value="subject">Sort by Subject</option>
          <option value="meetingName">Sort by Meeting Type</option>
          <option value="locationName">Sort by Location</option>
          <option value="approvalStatus">Sort by Status</option>
        </select>
      </div>

    </div>
  </div>
</div>

<div class="container-fluid py-3 px-4 left-menu-space" id="divMainContainer">

  <div class="page-title-box d-sm-flex justify-content-between bd-highlight">
    <h4 class="mb-0 f-bold-dubai text-secondary pb-3">User view</h4>
    <div class="page-title-right pb-3">
      <a class="btn btn-success text-white btn-sm"  routerLink="/userprofile"><i class="fa fa-arrow-left"></i> Back</a>
    </div>
  </div>
  <h5 class="text-secondary" *ngIf="getTodayMeeting().length>0"><b>Today</b></h5>

  <div class="bg-white p-4 text-center text-muted rounded mb-3" *ngIf="isLoader">
    <div class="loader-bg"></div>
  </div>
  <div class="bg-white py-4 text-center text-muted h-100 mb-3" *ngIf="meetingList.length ===0 && !isLoader ">
    <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
    <h5>No Data Available</h5>
  </div>
  <div class="card rounded pt-2 h-100" *ngFor="let item of getTodayMeeting()">
    <div class="pt-2 px-3 pb-3 border-bottom-0">
      <h6 class="card-title d-inline f-bold-dubai" style="cursor:pointer;" (click)="openModalnewMeeting(template1,item)">{{item.subjectAtd}}</h6>
      <div class="card-controls float-right">
        <ul class="list-inline list-badge hide-arrow-drop">
          <li class="list-inline-item">
            <a data-toggle="refresh" class="card-refresh text-black text-danger" (click)="openModalnewMeeting(template1,item)"><i class="la la-info-circle fa-lg mx-1"></i></a>
          </li>
          <li class="list-inline-item d-none-view">
            <a data-toggle="refresh" (click)="openFileModal(item)" class="card-refresh text-black mr-1 minus-5"><i class="la la-paperclip fa-lg mx-1 icon-rotate"></i> <span class="minus-5">{{item.noOfFile}}</span></a>
          </li>
          <li class="list-inline-item nav-item" ngbDropdown>
            <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><span class="d-none-view"> Actions </span><span class="p-0 d-none-view">{{item.noOfActionPoint}}</span><i class="la la-ellipsis-v fa-lg"></i></a>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <li><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-eye"></i> View</a></li>
              <li *ngIf="item.isApprover && item.published==4"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Approve</a></li>
              <li *ngIf="item.isReviewer && item.published==2"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Review</a></li>
              <li *ngIf="(item.workFlowCondition1 || item.published==5) && item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Publish</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="copyMeeting(item.genInfoAtdUno)"> <i class="fa fa-clone"></i> Copy</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="followupMeeting(item.genInfoAtdUno)"><i class="fa fa-mail-reply-all"></i> Followup</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="deleteMeeting(item.genInfoAtdUno)"><i class="fa fa-trash-o"></i> Delete</a></li>

            </ul>
          </li>
        </ul>
      </div>
      <div class="text-success py-1">{{item.approvalStatus}}</div>
      <div class="p-0 sm-small-size">
        <span class="pr-2"><i class="la la-calendar-o fa-lg"></i><span class="d-day">{{item.fMeetingDateAtd |  date:'EEE'}}</span>   {{item.fMeetingDateAtd |  date:'dd/MM/yyyy'}}  <span class="d-time">{{item.fStartTimeAtd | timeFormat}} - {{item.fEndTimeAtd | timeFormat}}</span></span> |  <span class="px-2"><i class="la la-map-marker fa-lg"></i> {{item.locationName !=''?item.locationName:'NA'}}</span> | <span class="px-2"><b class="text-secondary">Initiator:</b> {{item.initiatedBy}}</span>
      </div>
    </div>
  </div>

  <h5 class="text-secondary" *ngIf="getYesterdayMeeting().length>0"><b>Yesterday</b></h5>
  <div class="card rounded pt-2 h-100" *ngFor="let item of getYesterdayMeeting()">
    <div class="pt-2 px-3 pb-3 border-bottom-0">
      <h6 class="card-title d-inline f-bold-dubai" style="cursor:pointer;" (click)="openModalnewMeeting(template1,item)">{{item.subjectAtd}}</h6>
      <div class="card-controls float-right">
        <ul class="list-inline list-badge hide-arrow-drop">
          <li class="list-inline-item">
            <a data-toggle="refresh" class="card-refresh text-black text-danger" (click)="openModalnewMeeting(template1,item)"><i class="la la-info-circle fa-lg mx-1"></i></a>
          </li>
          <li class="list-inline-item d-none-view">
            <a data-toggle="refresh" (click)="openFileModal(item)" class="card-refresh text-black minus-5"><i class="la la-paperclip fa-lg mx-1 icon-rotate"></i> <span class="minus-5">{{item.noOfFile}}</span></a>
          </li>
          <li class="list-inline-item nav-item" ngbDropdown>
            <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><span class="d-none-view"> Actions <span class="p-0 d-none-view">{{item.noOfActionPoint}}</span></span><i class="la la-ellipsis-v fa-lg"></i></a>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <li><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-eye"></i> View</a></li>
              <li *ngIf="item.isApprover && item.published==4"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Approve</a></li>
              <li *ngIf="item.isReviewer && item.published==2"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Review</a></li>
              <li *ngIf="item.workFlowCondition1 || item.published==6"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Publish</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="copyMeeting(item.genInfoAtdUno)"> <i class="fa fa-clone"></i> Copy</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="followupMeeting(item.genInfoAtdUno)"><i class="fa fa-mail-reply-all"></i> Followup</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="deleteMeeting(item.genInfoAtdUno)"><i class="fa fa-trash-o"></i> Delete</a></li>

            </ul>
          </li>
        </ul>
      </div>
      <div class="text-success py-1">{{item.approvalStatus}}</div>
      <div class="p-0 sm-small-size">
        <span class="pr-2"><i class="la la-calendar-o fa-lg"></i><span class="d-day">{{item.fMeetingDateAtd |  date:'EEE'}}</span>   {{item.fMeetingDateAtd |  date:'dd/MM/yyyy'}}  <span class="d-time">{{item.fStartTimeAtd | timeFormat}} - {{item.fEndTimeAtd | timeFormat}}</span></span> |  <span class="px-2"><i class="la la-map-marker fa-lg"></i> {{item.locationName !=''?item.locationName:'NA'}}</span> | <span class="px-2"><b class="text-secondary">Initiator:</b> {{item.initiatedBy}}</span>
      </div>
    </div>
  </div>


  <h5 class="text-secondary" *ngIf="getOlderMeeting().length>0"><b>Older</b></h5>


  <div class="card rounded pt-2 h-100" *ngFor="let item of getOlderMeeting()">
    <div class="pt-2 px-3 pb-3 border-bottom-0">

      <h6 class="card-title d-inline f-bold-dubai" style="cursor:pointer;" (click)="openModalnewMeeting(template1,item)">{{item.subjectAtd}}</h6>
      <div class="card-controls float-right">
        <ul class="list-inline list-badge hide-arrow-drop">
          <li class="list-inline-item">
            <a data-toggle="refresh" class="card-refresh text-black text-danger" (click)="openModalnewMeeting(template1,item)"><i class="la la-info-circle fa-lg mx-1"></i></a>
          </li>
          <li class="list-inline-item d-none-view">
            <a data-toggle="refresh" (click)="openFileModal(item)" class="card-refresh text-black minus-5"><i class="la la-paperclip fa-lg mx-1 icon-rotate"></i> <span class="minus-5 pr-1">{{item.noOfFile}}</span></a>
          </li>
          <li class="list-inline-item nav-item" ngbDropdown>
            <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><span class="d-none-view"> Actions <span class="p-0 d-none-view">{{item.noOfActionPoint}}</span></span><i class="la la-ellipsis-v fa-lg"></i></a>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <li><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-eye"></i> View</a></li>
              <li *ngIf="item.isApprover && item.published==4"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Approve</a></li>
              <li *ngIf="item.isReviewer && item.published==2"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Review</a></li>
              <li *ngIf="item.workFlowCondition1 || item.published==6"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="fa fa-check-circle-o"></i> Publish</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="copyMeeting(item.genInfoAtdUno)"> <i class="fa fa-clone"></i> Copy</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="followupMeeting(item.genInfoAtdUno)"><i class="fa fa-mail-reply-all"></i> Followup</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="deleteMeeting(item.genInfoAtdUno)"><i class="fa fa-trash-o"></i> Delete</a></li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="text-success py-1">{{item.approvalStatus}}</div>
      <div class="p-0 sm-small-size">
        <span class="pr-2"><i class="la la-calendar-o fa-lg"></i><span class="d-day">{{item.fMeetingDateAtd |  date:'EEE'}}</span>   {{item.fMeetingDateAtd |  date:'dd/MM/yyyy'}}  <span class="d-time">{{item.fStartTimeAtd | timeFormat}} - {{item.fEndTimeAtd | timeFormat}}</span></span> |  <span class="px-2"><i class="la la-map-marker fa-lg"></i> {{item.locationName !=''?item.locationName:'NA'}}</span> | <span class="px-2"><b class="text-secondary">Initiator:</b> {{item.initiatedBy}}</span>
      </div>
    </div>
  </div>


  <div class="text-center" *ngIf="!disableMore"><a class="btn btn-sm btn-outline-secondary" (click)="loadGeneralInfo()">Load More..</a></div>
</div>

<ng-template #templateFile>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">File Attachment</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalPub.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12 px-2 pb-70">
        <div class="p-3 border rounded-bottom rounded-right bg-light my-3" *ngFor="let objFile of fileList">
          <span class="text-secondary f-bold-dubai pr-2">{{objFile.createByName}}</span> <small class="text-muted">{{objFile.createDate | date:'dd/MM/yyyy h:mm a '}}</small>
          <div class="attachement-card rounded p-2 mt-2">
            <i class="la fa-lg " [ngClass]="checkFileType(objFile.fileName)"></i> {{objFile.fileName}}
            <div class="card-controls float-right text-secondary pt-1">
              <ul class="list-inline list-badge hide-arrow-drop">

                <li class="list-inline-item nav-item" ngbDropdown>
                  <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg"></i></a>
                  <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <li><a ngbDropdownItem (click)="DownloadFiles(objFile)"><i class="fa fa-download"></i> Download</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-outline-secondary" (click)="modalPub.hide()">Close</button>

  </div>
</ng-template>
